import { colors } from 'styles/theme/colors';
// Shared types for the flow-map-first Route configuration UI.

export type FlowDirectionKey = 'out' | 'in'; // out = provider → destination
export type ArrowState = 'enabled' | 'disabled' | 'not-enableable';

export type Selection =
  | { kind: 'none' }
  | { kind: 'account'; integrationId: string; section?: string }
  | {
      kind: 'flow';
      destinationId: string;
      direction: FlowDirectionKey;
      section?: string;
    };

// Palette hexes duplicated from tailwind.config.js (route-green, gray-lines):
// React Flow strokes and SVG markers are attributes, so Tailwind class names
// can't reach them. Single source for every flow-map SVG color.
export const FLOW_COLORS: Record<ArrowState, string> = {
  enabled: colors['ui-event-priority-green'],
  disabled: colors['ui-divider-lines'],
  'not-enableable': colors['ui-divider-lines'],
};

// The shade each arrow takes on hover. Shared by the line and its arrowhead, so the
// two always change together.
export const FLOW_HOVER_COLORS: Record<ArrowState, string> = {
  enabled: colors['green-12'],
  disabled: colors['greyscale-7'],
  'not-enableable': colors['greyscale-7'],
};

// Line width per state, and how much thicker it gets on hover. The arrowhead
// scales with the line, so its hover marker shrinks by the same ratio to keep
// the head the same size.
export const FLOW_STROKE_WIDTHS: Record<ArrowState, number> = {
  enabled: 2.5,
  disabled: 2,
  'not-enableable': 2,
};
export const FLOW_HOVER_EXTRA_WIDTH = 1;

export type AccountBundle = {
  id: string;
  name: string;
  base_url: string;
  status?: string;
  owner?: { id: string; name: string }; // workspace the account belongs to
  techName: string; // integration type name, e.g. "EarthRanger"
  techValue: string; // integration type value, e.g. "earth_ranger"
  actions: any[]; // integration.type.actions (schema + ui_schema)
  configurations: any[]; // integration.configurations
  isProvider: boolean;
};
